import { render, staticRenderFns } from "./DetailGiro.vue?vue&type=template&id=edd8bcd8"
import script from "./DetailGiro.vue?vue&type=script&lang=js"
export * from "./DetailGiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports